
<header class="app-header">
  <header class="app-header1">
    <div class="header-banner1">
      <span class="banner-text">Gestion Produits - Système de Production Alpha</span>
    </div>
  </header>
  <div class="header-content">
    <div class="header-logo">
      <span class="logo-icon">📦</span>
      <span class="logo-text">Alpha Production</span>
    </div>

    <button class="hamburger-btn" (click)="toggleMenu()" *ngIf="auth.isLoggedIn()"
            [attr.aria-expanded]="menuOpen" aria-label="Menu de navigation">
      <span class="hamburger-line" [class.open]="menuOpen"></span>
      <span class="hamburger-line" [class.open]="menuOpen"></span>
      <span class="hamburger-line" [class.open]="menuOpen"></span>
    </button>

    <nav class="header-nav" [class.nav-open]="menuOpen" *ngIf="auth.isLoggedIn()">
      <a class="nav-link" routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="onProduitMenuClick()">Produit</a>
      <a class="nav-link" routerLink="/qualite-produit" routerLinkActive="active" (click)="closeMenu()">Assurance Qualité</a>
      <a class="nav-link" routerLink="/utilisateur" routerLinkActive="active" (click)="closeMenu()">Utilisateur</a>
      <a class="nav-link" routerLink="/profil" routerLinkActive="active" (click)="closeMenu()">Profil</a>
      <a class="nav-link" routerLink="/configuration" routerLinkActive="active" (click)="closeMenu()">Configuration</a>
      <a class="nav-link" routerLink="/workflow-employe" routerLinkActive="active" (click)="closeMenu()">Dossier Employé</a>
      <a class="nav-link logout-link" style="cursor:pointer" (click)="logout()">Logout</a>
    </nav>
  </div>
</header>

<div class="container page-content-wrap">
  <router-outlet></router-outlet>
</div>



